import { 
    FETCH_SUBSCRIPTIONS,
    FETCH_MYSUBSCRIPTIONS,
    SUBSCRIBE_TO_TOPIC,
} from '../constants/actionTypes'

const INITIAL_STATE = {
    subscriptions: [],
    mySubscriptions: [],   
}
export default (state=INITIAL_STATE, action)=> {
    switch (action.type) {
        case FETCH_SUBSCRIPTIONS:
            return {
                ...state,
                subscriptions: action.payload
            }
           
        case FETCH_MYSUBSCRIPTIONS:
            return {
                ...state,
                mySubscriptions: action.payload
            }
        case SUBSCRIBE_TO_TOPIC:
            return {
                ...state,
                mySubscriptions: action.payload
            }
        case 'GET_MESSAGING_TOKEN':
        return {
            ...state,
            notificationToken: action.payload
        }
        default: 
            return state;
    }

}



// WEBPACK FOOTER //
// ./src/reducers/subscriptions.js